angular.module('cian.ui.dropdown', ['cian.ui.popup'])
.config(["$interpolateProvider", function($interpolateProvider) {
  $interpolateProvider.startSymbol('{$');
  $interpolateProvider.endSymbol('$}');
}]);

angular.module('cian.ui.dropdown')
.directive('dropdown', ['$log', "PopupService", function ($log, PopupService) {
  return {
      scope: true,
      restrict: 'EA',
      template: '<div button text="{$ ::text $}" action="true" is-popup-open="isPopupOpen" arrow="true" button-style="{$ isPopupOpen?\'solid\':\'bright\' $}"></div>',
      link: function(scope, element, attrs) {
        scope.text = attrs.text;
        scope.dropdownCtrl = attrs.dropdownCtrl;
        scope.dropdownTemplateUrl = attrs.dropdownTemplateUrl;

        var button = element[0].querySelector('.s-button');

        angular.element(button).on('click', function() {
          scope.isPopupOpen = true;
          PopupService.show({
              scope: scope.$new(),
              anchorElement: button,
              controller: scope.dropdownCtrl,
              align: 'left',
              templateUrl: scope.dropdownTemplateUrl
            })
            .then(function(modal) {
              modal.close.then(function(result) {
                $log.debug('dropdown closed', result);
                scope.selected = result;
                scope.isPopupOpen = false;
              });
            });
        });
      }
    };
}]);



//////////////////
// WEBPACK FOOTER
// ../components/ui/src/dropdown/dropdown.js
// module id = 905
// module chunks = 0